/**
 *  Component: Installation Section
 */
import React from 'react';

import { StyledTypography } from 'styles/common';

import { Download1Icon } from 'constants/icons';

import { BodyContainer, FormContainer, FormHeading, Separator, Icon } from '../styles';

const Item = ({ children, isTopItem = false }) => (
  <StyledTypography bottomGutter={1} topGutter={isTopItem ? 1 : 0}>
    {children}
  </StyledTypography>
);

const InstallationSection = () => (
  <FormContainer>
    <FormHeading>
      <Icon>
        <Download1Icon size="fixed16px" />
      </Icon>
      Installation Steps
    </FormHeading>
    <Separator />
    <BodyContainer>
      <Item isTopItem>1. Click the "Install" button above. A popup will open in MS Teams.</Item>
      <Item>2. Click on "Add" to add in your workspace.</Item>

      <Item isTopItem>Alternatively, you can also,</Item>

      <Item>1. Open MS Teams, Click on Apps on the bottom left.</Item>
      <Item>2. Search for "Mesh" using search box and click on "Mesh" App.</Item>
      <Item>3. Click on "Add" to be able to use the personal tabs.</Item>
    </BodyContainer>
  </FormContainer>
);

export default InstallationSection;
